import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import ConfrereButton from '../ConfrereButton';
import { setNetworkConnection } from '../../store/slices/statusSlice';

function NetworkRetest() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
      <ConfrereButton
        sx={{ margin: '8px 16px' }}
        size="small"
        color="primary"
        variant="contained"
        onClick={() => dispatch(setNetworkConnection(''))}
      >
        {t('Re-test network')}
      </ConfrereButton>
    </Box>
  );
}

export default NetworkRetest;
